export default {"src":"/_next/static/media/painting_workshop.e1bfadfd.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};